import { render, staticRenderFns } from "./ReportSSSAward.vue?vue&type=template&id=4c08c049&"
import script from "./ReportSSSAward.vue?vue&type=script&lang=js&"
export * from "./ReportSSSAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports